/* eslint-disable no-underscore-dangle */
import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductCustomizerPlayer extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      header: '.js-header',
      customizerWrap: '.js-customizerWrap',
      customizerPlayer: '#tk-treble-root',
    };

    this.dom = {
      $component: component,
      $customizerWrap: this.$get(this.refs.customizerWrap),
      $customizerPlayer: this.$get(this.refs.customizerPlayer),
    };

    this.state = {
      shimmerClass: 'LoadingShimmer',
    };

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    const { dom } = this;
    const config = { childList: true };
    const observer = new MutationObserver(this.removeLoader.bind(this));
    observer.observe(dom.$customizerPlayer, config);
  }

  removeLoader() {
    const { dom, state } = this;
    dom.$customizerWrap.classList.remove(state.shimmerClass);
  }
}
